export default "__VITE_ASSET__dcb929c5__"